import { InfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"
import { JudgeEnteredArgs } from "~/entities/InputProfileFlow/JudgeEntered"

export type GetStudentInputFlowJudgeEntered = InfraResponse<{
  total_page_count: number
  entered_page_count: number
  entered_rate: number
  judge_entered: JudgeEnteredArgs
}>

const PATH = "/student/input-flow/judge_entered"

export const fetchGetStudentInputFlowJudgeEntered = defineFetcher((): Promise<GetStudentInputFlowJudgeEntered> => {
  return GET(PATH)
})
